import moment from "moment";

export default function formatDate(date) {
  if (!date) return "";
  return moment(date).locale("th").format("D MMM YY");
}
